import { AfterViewInit, Component } from '@angular/core';
import {
  TextFieldBuilderComponent
} from '@app/shared/components/fields/text-field-builder/text-field-builder.component';
import path from 'path-browserify';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'file-name-header-field-builder',
    templateUrl: '../text-field-builder.component.html',
    standalone: false
})
export class FileNameFieldBuilderComponent extends TextFieldBuilderComponent implements AfterViewInit {

  /**
   * Get the file name without extension.
   * @param name The file name.
   * @returns The file name without extension.
   */
  private getNameWithoutExtension(name: string): string {
    return path.basename(name, this.getExtension(name));
  }

  /**
   * Get the file extension.
   * @param name The file name.
   * @returns The file extension.
   */
  private getExtension(name: string): string {
    return path.extname(name);
  }

  /**
   * Enables the field to be edited in whichever way it functions
   */
  public edit(): void {
    super.edit();
    this.form.controls.field.setValue(this.getNameWithoutExtension(this.getFieldValue()));
  }

  /**
   * Set up the hooks for the field.
   */
  public ngAfterViewInit(): void {
    this.setupHooks();

    this.form.controls.field.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(50),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value) => {
      if (value !== this.getFieldInitialValue()) {
        this.setFieldValue(value + this.getExtension(this.getFieldInitialValue()));
      }
    });
  }
}
